export const nav: Record<string, string> = {
  'nav.dashboard': 'Tổng quan',
  'nav.game': 'Supernova Connect',
  'nav.marketing': 'Marketing / UA',
  'nav.marketing.reports': 'Báo cáo',
  'nav.marketingReport': 'Báo cáo Marketing',
  'nav.marketing.playableAds': 'Playable Ads',
  'nav.help': 'Trợ giúp',
  'help.empty': 'Chưa có hướng dẫn nào cho các công cụ bạn được dùng.',
  'help.more': 'Hướng dẫn cho các công cụ khác sẽ được bổ sung dần.',
  'help.guide.playableAds.title': 'Ads Builder (Playable Ads)',
  'help.guide.playableAds.description': 'Dựng quảng cáo nhiều màn: thành phần, nhóm, chuyển màn, timeline, chạy thử và xuất Playable / ảnh / video.',
  'nav.marketing.localize': 'Localize',
  'nav.marketing.competitor': 'Đối thủ',
  'nav.marketing.creativeSpy': 'Creative Spy',
  'nav.marketing.campaignEditor': 'Campaign Editor',
  'nav.marketing.uaAlerts': 'Cảnh báo UA',
  'nav.marketing.appSpy': 'App Spy',
  'nav.monetization': 'Monetization',
  'nav.monetization.reports': 'Báo cáo',
  'nav.monetization.ecpm': 'eCPM Tracker',
  'nav.monetization.admob': 'AdMob Mediation',
  'nav.monetization.encrypt': 'Encrypt',
  'nav.monetization.appAssignment': 'App Assignment',
  'nav.monetization.moLead': 'Lead MO',
  'nav.developer': 'Developer',
  'nav.developer.reports': 'Báo cáo',
  'nav.developer.encrypt': 'Mã hóa',
  'nav.developer.adsDecode': 'Ads Decode',
  'nav.growth': 'Growth',
  'nav.growth.uaBotConsole': 'UA Bot Console',
  'nav.growth.firebaseRc': 'Firebase Remote Config',
  'nav.growth.eventAnalytics': 'Event Analytics',
  'nav.hr': 'Nhân sự',
  'nav.hr.holidays': 'Ngày lễ',
  'nav.hrAdmin': 'Quản lý HR',
  'nav.employees': 'Nhân viên',
  'nav.hrAdmin.leave': 'Quản lý nghỉ phép',
  'nav.hrAdmin.config': 'Cấu hình',
  'nav.hrAdmin.loginLogs': 'Nhật ký đăng nhập',
  'nav.products': 'Sản phẩm',
  'nav.admin': 'Quản trị',
  'nav.admin.settings': 'Cài đặt',
  'nav.devPermissions': 'Phân quyền Dev',
  'nav.finance': 'Tài chính',
  'nav.finance.overview': 'Doanh thu & Chi phí',
  'nav.finance.products': 'Sản phẩm',
  'nav.finance.commission': 'Hoa hồng',
  'nav.finance.dividend': 'Phân bổ cổ tức',
  'nav.profile': 'Hồ sơ của tôi',
  'nav.examMy': 'Bài thi của tôi',
  'nav.examAdmin': 'Quản lý thi',
  'nav.examAdmin.tests': 'Danh sách bài thi',
  'nav.examAdmin.questions': 'Câu hỏi',
  'nav.examAdmin.create': 'Tạo bài thi',
  // Exam pages reached from a button, not from the sidebar: they still need a header title.
  'nav.examTake': 'Làm bài thi',
  'nav.examResult': 'Kết quả bài thi của tôi',
  'nav.examAdmin.grade': 'Chấm bài thi',
  'nav.examAdmin.results': 'Kết quả bài thi',
  'nav.leave': 'Nghỉ phép của tôi',
  // OKR admin → Cycles tab → mục tiêu doanh thu công ty
  'targets.intro': 'Mục tiêu doanh thu cả năm của công ty. Quý = 1/4, 6 tháng = 1/2 số này.',
  'targets.year': 'Năm',
  'targets.grossRev': 'Doanh thu gộp (USD)',
  'targets.save': 'Lưu mục tiêu',
  'targets.saved': 'Đã lưu mục tiêu.',
  'targets.stored': 'Mục tiêu đã đặt',
  'targets.none': 'Chưa đặt mục tiêu năm nào.',
  // Login page
  'login.subtitle': 'Đăng nhập để tiếp tục',
  'login.signInWithGoogle': 'Đăng nhập với Google',
  'login.accessDenied': 'Tài khoản chưa được cấp quyền truy cập hệ thống. Vui lòng liên hệ quản trị viên.',
  // App layout
  'layout.appName': 'Supernova',
  'layout.toggleSidebar': 'Thu/mở sidebar',
  'layout.toggleTheme': 'Chế độ tối',
  'layout.tagline': 'Không gian vận hành',
  // Header bell (in-app notifications)
  'notify.title': 'Thông báo',
  'notify.unread': 'Chưa đọc',
  'notify.markAllRead': 'Đánh dấu tất cả đã đọc',
  'notify.empty': 'Chưa có thông báo nào.',
  'notify.open': 'Mở',
  'notify.viewIssue': 'Xem issue',
  'notify.close': 'Đóng',
  'notify.new': 'Mới',
  'notify.filterAll': 'Tất cả',
  'notify.kind.issue': 'Issues',
  'notify.kind.doc': 'Tài liệu',
  'notify.kind.leave': 'Nghỉ phép',
  'notify.kind.event': 'Sự kiện',
  'notify.kind.product': 'Sản phẩm',
  'notify.kind.handbook': 'Sổ tay',
  'notify.kind.announce': 'Thông báo chung',
  'notify.kind.system': 'Hệ thống',
  'notify.kind.okr': 'OKR',
  'notify.kind.game': 'Supernova Connect',
  'notify.kind.ua': 'Cảnh báo UA',
  // Dashboard
  // Dashboard overview
  'dash.greeting': 'Chào',
  'dash.tabOverview': 'Tổng quan',
  'dash.myLeaveWork': 'Phép & ngày công của tôi',
  'dash.leaveRemaining': 'Phép còn lại',
  'dash.leaveUsed': 'Đã dùng',
  'dash.leaveEarned': 'Phép năm',
  'dash.workingDaysMonth': 'Ngày công (tháng này)',
  'dash.requestLeave': 'Xin nghỉ',
  'dash.reportOverview': 'Tổng quan báo cáo',
  'dash.thisMonth': 'tháng này',
  'dash.viewDetail': 'Xem chi tiết →',
  'dash.days': 'ngày',
  'dash.weekRankTitle': 'Top 5 app theo tuần',
  'dash.weekRankSub': '5 tuần gần nhất · theo lợi nhuận',
  'dash.weekLossRankTitle': 'Top 5 app lỗ theo tuần',
  'dash.weekLossRankSub': '5 tuần gần nhất · lỗ nhiều nhất',
  'dash.topCol': 'Top',
  'dash.week': 'Tuần',
};
